export let SESSION_STORAGE_KEY = {
    CONFIG: 'kookmin-univ-config',
    CODE: 'kookmin-univ-code',
    AUTHENTICATION: 'kookmin-univ-authentication',
    SEMESTER: 'kookmin-univ-semester',
    CURRENT_SEMESTER: 'kookmin-univ-current-semester',
    AGREE_ALL: 'kookmin-univ-agree-all',
    SESSION_VALID_TIME: 'kookmin-univ-session-valid-time',
    CAPTCHA: 'google-recaptcha-site-key',
};

export let COM_PROPERTIES_KEY = {
    CURRENT_SEMESTER: 'CURRENT-SEMESTER',
};

export let WEB_TYPE = {
    FOR_STUDENT: 'STUDENT',
    FOR_STAFF: 'STAFF',
};

export let ROLE = {
    ADMIN: 'ADMIN',
    STAFF: 'STAFF',
    STUDENT: 'STUDENT',
};

export let CODE_GROUP_ID = {
    USER_ROLE: 'USER_ROLE',
    SEMESTER: 'SEMESTER',
    SEMESTER_YEAR: 'SEMESTER_YEAR',
    SEMESTER_TYPE: 'SEMESTER_TYPE',
    USER_UNIVERSITY: 'USER_UNIVERSITY',
    MAIN_UNIVERSITY: 'MAIN_UNIVERSITY',
    SUBJECT_TYPE: 'SUBJECT_TYPE',
    LESSON_TYPE: 'LESSON_TYPE',
    ENROLMENT_VALID_STATUS: 'ENROLMENT_VALID_STATUS',
    ENROLMENT_REG_STATUS: 'ENROLMENT_REG_STATUS',
    USER_REG_VALID_STATUS: 'USER_REG_VALID_STATUS',
    NOTICE_TYPE: 'NOTICE_TYPE',
    FAQ_TYPE: 'FAQ_TYPE',
    BOARD_TYPE: 'BOARD_TYPE',
    POSTING_TYPE: 'POSTING_TYPE',
    USE_STATUS: 'USE_STATUS',
    WEEKDAY: 'WEEKDAY',
    ID_REG_STATUS: 'ID_REG_STATUS',
    ANSWER_STATUS: 'ANSWER_STATUS',
    SCHEDULE_TYPE: 'SCHEDULE_TYPE',
    CREDIT_TYPE: 'CREDIT_TYPE',
    UNIV_ENROLMENT_REG_STATUS: 'UNIV_ENROLMENT_REG_STATUS',
    SMS_SEND_TYPE: 'SMS_SEND_TYPE',
    SMS_SEND_RESULT: 'SMS_SEND_RESULT',
    SMS_CALLING_NUMBER: 'SMS_CALLING_NUMBER',
    UNIVERSITY_TYPE: 'UNIVERSITY_TYPE',
    ENROLMENT_ENABLE_STATUS: 'ENROLMENT_ENABLE_STATUS',
    ENROLMENT_TIME: 'ENROLMENT_TIME',
};

export let ENROLMENT_TIME = {
    START_TIME: 'START_TIME',
    END_TIME: 'END_TIME',
};

export let NOTICE_CHECK_STATUS_CD = {
    CONFIRM: 'CONFIRM',
    WAITING: 'WAITING',
};

export let ENROLMENT_VALID_STATUS = {
    APPROVE: 'APPROVE',
    WAITING: 'WAITING',
    REJECT: 'REJECT',
};

export let ENROLMENT_REG_STATUS = {
    WAITING: 'WAITING',
    REGIST: 'REGIST',
    REJECT: 'REJECT',
    WITHDRAW: 'WITHDRAW',
};

export let TIMEPICKER = {
    MIN_TIME: '08:00',
    MAX_TIME: '11:00',
    STEP: '300',
};

export let UNIVERSITY_TYPE = {
    MAIN: 'MAIN',
    SUB: 'SUB',
};

export let ENROLMENT_ENABLE_STATUS = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
};

export let FILE_TYPE = {
    PDF: 'application/pdf',
    PNG: 'image/png',
    JPG: 'image/jpeg',
    JPEG: 'image/jpeg',
    GIF: 'image/gif',
    EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export let PATH_DELIMITER = '/';
export let ROOT = '';
export let ALL = '*';
export let ALL_PATH = PATH_DELIMITER + ALL;

export let HOME = '';
export let HOME_PATH = PATH_DELIMITER + HOME;

export let MAIN = HOME;
export let MAIN_PATH = HOME_PATH;

export let LOGIN = 'login';
export let LOGIN_PATH = PATH_DELIMITER + LOGIN;

export let FIND_ID_PW = 'find-id-pw';
export let FIND_ID_PW_PATH = PATH_DELIMITER + FIND_ID_PW;

export let JOIN_US = 'join-us';
export let JOIN_US_PATH = PATH_DELIMITER + JOIN_US;

export let JOIN_US_PHASE1 = JOIN_US_PATH + PATH_DELIMITER + '1';
export let JOIN_US_PHASE2 = JOIN_US_PATH + PATH_DELIMITER + '2';
export let JOIN_US_PHASE3 = JOIN_US_PATH + PATH_DELIMITER + '3';

export let PASSWORD_RESET = 'password-reset';
export let PASSWORD_RESET_PATH = PATH_DELIMITER + PASSWORD_RESET;

export let USER_INFO = 'user-info';
export let USER_INFO_PATH = PATH_DELIMITER + USER_INFO;

export let PAGE_404_PATH = PATH_DELIMITER + '404';
export let PAGE_500_PATH = PATH_DELIMITER + '500';

//----------------------------------------------------------------------
export let ADD = 'add';
export let ADD_PATH = PATH_DELIMITER + ADD;
export let DETAIL = 'detail';
export let DETAIL_PATH = PATH_DELIMITER + DETAIL;
export let EDIT = 'edit';
export let EDIT_PATH = PATH_DELIMITER + EDIT;
//----------------------------------------------------------------------

export let SUBJECT_SEARCH = 'subject-search';
export let SUBJECT_SEARCH_PATH = PATH_DELIMITER + SUBJECT_SEARCH;

export let SUBJECT_SEARCH_BODY = 'subject-search-body';
export let SUBJECT_SEARCH_BODY_PATH = SUBJECT_SEARCH_PATH + PATH_DELIMITER + SUBJECT_SEARCH_BODY;

export let SYSTEM = 'system';
export let SYSTEM_PATH = PATH_DELIMITER + SYSTEM;

export let SYSTEM_TERM = 'term';
export let SYSTEM_TERM_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_TERM;

export let SYSTEM_ENROLMENT_NOTICE = 'enrolment-notice';
export let SYSTEM_ENROLMENT_NOTICE_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_ENROLMENT_NOTICE;

export let SYSTEM_SUBJECT_CODE = 'subject-code';
export let SYSTEM_SUBJECT_CODE_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_SUBJECT_CODE;

export let SYSTEM_SUBJECT_CODE_BODY = 'subject-code-body';
export let SYSTEM_SUBJECT_CODE_BODY_PATH = SYSTEM_SUBJECT_CODE_PATH + PATH_DELIMITER + SYSTEM_SUBJECT_CODE_BODY;

export let SYSTEM_COMMON_CODE = 'common-code';
export let SYSTEM_COMMON_CODE_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_COMMON_CODE;

export let SYSTEM_UNIVERSITY = 'university';
export let SYSTEM_UNIVERSITY_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_UNIVERSITY;

export let SYSTEM_UNIVERSITY_MANAGER = 'university-manager';
export let SYSTEM_UNIVERSITY_MANAGER_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_UNIVERSITY_MANAGER;

export let SYSTEM_USER = 'user';
export let SYSTEM_USER_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_USER;

export let SYSTEM_LOGIN_HISTORY = 'login-history';
export let SYSTEM_LOGIN_HISTORY_PATH = SYSTEM_PATH + PATH_DELIMITER + SYSTEM_LOGIN_HISTORY;

export let SEMESTER = 'semester';
export let SEMESTER_PATH = PATH_DELIMITER + SEMESTER;

export let SEMESTER_SUBJECT = 'subject';
export let SEMESTER_SUBJECT_PATH = SEMESTER_PATH + PATH_DELIMITER + SEMESTER_SUBJECT;

export let SEMESTER_STUDENT_UNIVERSITY = 'student-university';
export let SEMESTER_STUDENT_UNIVERSITY_PATH = SEMESTER_PATH + PATH_DELIMITER + SEMESTER_STUDENT_UNIVERSITY;

export let SEMESTER_STUDENT_ENROLMENT_CHECK = 'student-enrolment-check';
export let SEMESTER_STUDENT_ENROLMENT_CHECK_PATH = SEMESTER_PATH + PATH_DELIMITER + SEMESTER_STUDENT_ENROLMENT_CHECK;

export let SEMESTER_ENROLMENT_STATUS = 'enrolment-status';
export let SEMESTER_ENROLMENT_STATUS_PATH = SEMESTER_PATH + PATH_DELIMITER + SEMESTER_ENROLMENT_STATUS;

export let SEMESTER_TOTAL_ENROLMENT_STATUS = 'total-enrolment-status';
export let SEMESTER_TOTAL_ENROLMENT_STATUS_PATH = SEMESTER_PATH + PATH_DELIMITER + SEMESTER_TOTAL_ENROLMENT_STATUS;

export let SEMESTER_ENROLMENT_MANAGEMENT = 'enrolment-management';
export let SEMESTER_ENROLMENT_MANAGEMENT_PATH = SEMESTER_PATH + PATH_DELIMITER + SEMESTER_ENROLMENT_MANAGEMENT;

export let ENROLMENT = 'enrolment';
export let ENROLMENT_PATH = PATH_DELIMITER + ENROLMENT;

export let ENROLMENT_SEARCH_SUBJECT = 'enrolment-subject';
export let ENROLMENT_SEARCH_SUBJECT_PATH = ENROLMENT_PATH + PATH_DELIMITER + ENROLMENT_SEARCH_SUBJECT;

export let ENROLMENT_ENROLMENT_RESULT = 'enrolment-result';
export let ENROLMENT_ENROLMENT_RESULT_PATH = ENROLMENT_PATH + PATH_DELIMITER + ENROLMENT_ENROLMENT_RESULT;

export let ENROLMENT_SCHEDULE_TABLE = 'schedule-table';
export let ENROLMENT_SCHEDULE_TABLE_PATH = ENROLMENT_PATH + PATH_DELIMITER + ENROLMENT_SCHEDULE_TABLE;

export let COMMUNITY = 'community';
export let COMMUNITY_PATH = PATH_DELIMITER + COMMUNITY;

export let COMMUNITY_NOTICE = 'notice';
export let COMMUNITY_NOTICE_PATH = COMMUNITY_PATH + PATH_DELIMITER + COMMUNITY_NOTICE;

export let COMMUNITY_NOTICE_BODY = 'notice-body';
export let COMMUNITY_NOTICE_BODY_PATH = COMMUNITY_NOTICE_PATH + PATH_DELIMITER + COMMUNITY_NOTICE_BODY;

export let COMMUNITY_NOTICE_ADD = ADD;
export let COMMUNITY_NOTICE_ADD_PATH = COMMUNITY_NOTICE_PATH + PATH_DELIMITER + COMMUNITY_NOTICE_ADD;

export let COMMUNITY_NOTICE_DETAIL = DETAIL;
export let COMMUNITY_NOTICE_DETAIL_PATH = COMMUNITY_NOTICE_PATH + PATH_DELIMITER + COMMUNITY_NOTICE_DETAIL;

export let COMMUNITY_NOTICE_EDIT = EDIT;
export let COMMUNITY_NOTICE_EDIT_PATH = COMMUNITY_NOTICE_PATH + PATH_DELIMITER + COMMUNITY_NOTICE_EDIT;

export let COMMUNITY_FAQ = 'faq';
export let COMMUNITY_FAQ_PATH = COMMUNITY_PATH + PATH_DELIMITER + COMMUNITY_FAQ;

export let COMMUNITY_FAQ_BODY = 'faq-body';
export let COMMUNITY_FAQ_BODY_PATH = COMMUNITY_FAQ_PATH + PATH_DELIMITER + COMMUNITY_FAQ_BODY;

export let COMMUNITY_FAQ_ADD = ADD;
export let COMMUNITY_FAQ_ADD_PATH = COMMUNITY_FAQ_PATH + PATH_DELIMITER + COMMUNITY_FAQ_ADD;

export let COMMUNITY_FAQ_DETAIL = DETAIL;
export let COMMUNITY_FAQ_DETAIL_PATH = COMMUNITY_FAQ_PATH + PATH_DELIMITER + COMMUNITY_FAQ_DETAIL;

export let COMMUNITY_FAQ_EDIT = EDIT;
export let COMMUNITY_FAQ_EDIT_PATH = COMMUNITY_FAQ_PATH + PATH_DELIMITER + COMMUNITY_FAQ_EDIT;

export let COMMUNITY_QNA = 'qna';
export let COMMUNITY_QNA_PATH = COMMUNITY_PATH + PATH_DELIMITER + COMMUNITY_QNA;

export let COMMUNITY_QNA_BODY = 'qna-body';
export let COMMUNITY_QNA_BODY_PATH = COMMUNITY_QNA_PATH + PATH_DELIMITER + COMMUNITY_QNA_BODY;

export let COMMUNITY_QNA_ADD = ADD;
export let COMMUNITY_QNA_ADD_PATH = COMMUNITY_QNA_PATH + PATH_DELIMITER + COMMUNITY_QNA_ADD;

export let COMMUNITY_QNA_DETAIL = DETAIL;
export let COMMUNITY_QNA_DETAIL_PATH = COMMUNITY_QNA_PATH + PATH_DELIMITER + COMMUNITY_QNA_DETAIL;

export let COMMUNITY_QNA_EDIT = EDIT;
export let COMMUNITY_QNA_EDIT_PATH = COMMUNITY_QNA_PATH + PATH_DELIMITER + COMMUNITY_QNA_EDIT;

export let SMS = 'sms';
export let SMS_PATH = PATH_DELIMITER + SMS;

export let SMS_SEND = 'sms-send';
export let SMS_SEND_PATH = SMS_PATH + PATH_DELIMITER + SMS_SEND;

export let SMS_HISTORY = 'sms-history';
export let SMS_HISTORY_PATH = SMS_PATH + PATH_DELIMITER + SMS_HISTORY;

// TODO 테스트용 삭제처리
export let TEST = 'test';
export let TEST_PATH = PATH_DELIMITER + 'test';

// TODO 테스트용 삭제처리
export let TEST_MODAL = 'modal';
export let TEST_MODAL_PATH = TEST + PATH_DELIMITER + TEST_MODAL;
